import { render, staticRenderFns } from "./Diagram1.vue?vue&type=template&id=85a93652&scoped=true&"
import script from "./Diagram1.vue?vue&type=script&lang=js&"
export * from "./Diagram1.vue?vue&type=script&lang=js&"
import style0 from "./Diagram1.vue?vue&type=style&index=0&id=85a93652&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85a93652",
  null
  
)

export default component.exports